import { Moment } from "moment";
import { IPrioritySchedulerColumnData } from "@miplatform/components";
import { IAttempt, IUserListItemResponse } from "@miplatform/types";
import { addWorkDays, isSame, toFormattedDate } from "@miplatform/utils";

export const buildUserColumns = ({
  users,
  events,
}: {
  users: IUserListItemResponse[];
  events: IAttempt[];
}): IPrioritySchedulerColumnData[] => {
  const columns = users.map((user) => ({
    id: `${user.id}-column`,
    user,
    events: events.filter((event) => event.assignedUserId === user.id),
    dateView: false,
  }));

  return columns;
};

export const buildDateColumns = ({
  date,
  events,
  numberOfDays = 5,
}: {
  date: Moment;
  events: IAttempt[];
  numberOfDays?: number;
}): IPrioritySchedulerColumnData[] => {
  const dates = [];

  for (let i = 0; i < numberOfDays; i++) {
    dates.push(addWorkDays(i, date));
  }

  const columns = dates.map((date) => ({
    id: `${toFormattedDate(date)}-column`,
    date,
    events: events.filter((event) =>
      isSame({
        date1: event.scheduledStartDate,
        date2: date,
        timeUnit: "day",
      })
    ),
    dateView: true,
  }));
  return columns;
};
